import axios from 'axios'
import config from '../config'

const url = path => `${config.apiPath}${path}`

export const uploadFile = (token, file) => {
  return axios({
    url: url('/uploads'),
    method: 'post',
    data: {
      id: file.id,
      fileName: file.name,
      fileSize: file.size,
      contentType: file.type,
    },
    headers: { Authorization: `Bearer ${token}` },
  }).then(response => response.data)
}
